import React from "react";
import { withFormik, Form, Field } from "formik";

export const RecipeAdminList = ({ list, handleSearch, recipe }) => {
  const validate = (values, props) => {
    let errors = {};
    if (!values.email) {
      errors.email = "Email is required";
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
    ) {
      errors.email = "Invalid email address";
    }

    return errors;
  };

  const SearchUserFormComponent = (props) => {
    const {
      values,
      handleChange,
      dirty,
      errors,
      touched,
      isSubmitting,
      recipe,
    } = props;

    return (
      <Form className="search-user-form">
        <div
          className={
            "form-group form-group-lg " +
            (errors.email && touched.email ? "has-error" : "")
          }
        >
          <label htmlFor="email" className="control-label">
            Email <span className="text-danger">*</span>
          </label>
          <Field
            type="email"
            aria-describedby="emailAddressHelpBlock"
            className="form-control"
            name="email"
            value={values.email}
            onChange={handleChange}
            maxLength="50"
          />
          {errors.email && touched.email && (
            <div className="exception-margin text-danger" role="alert">
              <span
                className="glyphicon glyphicon-warning-sign"
                aria-hidden="true"
              >
                <span className="sr-only">Error:</span>
              </span>{" "}
              {touched.email && errors.email}
            </div>
          )}
        </div>
        <button
          type="submit"
          className="btn btn-primary btn-lg btn-block"
          disabled={!dirty || Object.keys(errors).length !== 0 || isSubmitting}
        >
          Add admin user
        </button>
      </Form>
    );
  };

  const SearchUserForm = withFormik({
    mapPropsToValues({ email, showNotification, hideNotification }) {
      return {
        email: email || "",
        showNotification,
        hideNotification,
      };
    },
    validate: validate,
    handleSubmit(values, { props, setSubmitting }) {
      let { email } = values;
      return handleSearch(recipe, email);
    },
  })(SearchUserFormComponent);

  const UserList = ({ list }) => {
    if (list.length) {
      const _list = list.map((item) => {
        return <li key={item.id}>{item.email}</li>;
      });
      return <ul>{_list}</ul>;
    } else {
      return (
        <div>
          <p>You haven't shared any recipes yet.</p>
        </div>
      );
    }
  };

  return (
    <div className="recipeAdminList">
      <UserList list={list} />
      <SearchUserForm />
    </div>
  );
};
